// 类型
export const ORGANIZE_TYPE = {
    1: '林氏',
    2: '供应商',
    linsy: {
        key: 1,
        value: '林氏'
    },
    supplier: {
        key: 2,
        value: '供应商'
    }
}
// 类型
export const ORGANIZE_TYPE_LIST = [
    {
        key: 1,
        name: '林氏'
    },
    {
        key: 2,
        name: '供应商'
    }
]
// 状态
export const STATUS = {
    1: '启用',
    0: '停用',
    2: '未启用',
    start: {
        key: 1,
        value: '启用'
    },
    stop: {
        key: 0,
        value: '停用'
    },
    unStart: {
        key: 2,
        value: '未启用'
    }
}
export const STATUS_LIST = [
    {
        key: 1,
        name: '启用'
    },
    {
        key: 0,
        name: '停用'
    },
    {
        key: 2,
        name: '未启用'
    }
]
